__turbopack_context__.v({
  "changeMarginRight": "LaitLoader-module__DZs32q__changeMarginRight",
  "changeMarginRightSecondSpan": "LaitLoader-module__DZs32q__changeMarginRightSecondSpan",
  "loader": "LaitLoader-module__DZs32q__loader",
  "secondSpan": "LaitLoader-module__DZs32q__secondSpan",
  "transformSecondSpan": "LaitLoader-module__DZs32q__transformSecondSpan",
});
